@if (!props.readonly) {
  <cap-input-number
    [formControl]="formControl"
    [locale]="props?.locale_format"
    [prefix]="props?.prefix"
    [attr.data-test]="'builder-' + field.key"
    [suffix]="props?.suffix"
    [useGrouping]="props?.group_thousands"
    [minFractionDigits]="props?.decimals || 0"
    [maxFractionDigits]="props?.decimals || 0"
    [disabled]="props?.readonly"
    [selectOnFocus]="props?.select_on_focus"
    [min]="props?.min"
    [max]="props?.max"
    [styleClass]="props?.readonly ? 'cap-number-format-readonly' : ''"
    [autocomplete]="props?.autocomplete"
    [readonly]="props.readonly">
    @if (props?.content_left) {
      <ng-template capTemplate="content-left">{{ props.content_left }}</ng-template>
    }

    @if (props?.content_right) {
      <ng-template capTemplate="content-right">{{ props.content_right }}</ng-template>
    }
  </cap-input-number>
}

<cpb-readonly-container
  [hidden]="!props.readonly || !hasReadableValue(formControl.value)"
  [attr.data-test]="'builder-readonly-' + field.key">
  {{ props.content_left }}
  {{ props.prefix }}

  @if (props.filter_type !== 'pint' && props.filter_type !== 'int') {
    {{ formControl.value | number: '1.' + (props.decimals || 0) + '-' + (props.decimals || 0) : props.locale_format }}
  } @else {
    {{ formControl.value }}
  }
  {{ props.suffix }}
  {{ props.content_right }}
</cpb-readonly-container>
